<template>
  <BasicLayout>
    <template #wrapper>
      <basic />

      <botTable class="mtop" />
      <el-card>
        <div slot="header" class="clearfix">
          <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
            <el-form-item label="开始日期" prop="startDate">
              <el-date-picker
                v-model="queryParams.startDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>

            <el-form-item label="结束日期" prop="endDate">
              <el-date-picker
                v-model="queryParams.endDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-row :gutter="12">
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <userSpin ref="botStealStat" :c="'%'" :chart-title="'偷概率'" :k="'stealRate'" />
          </el-col>
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <userSpin ref="botAttackStat" :c="'%'" :chart-title="'打概率'" :k="'attackRate'" />
          </el-col>
        </el-row>

        <!--        <el-row :gutter="12">-->
        <!--          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">-->
        <!--            <userSpin ref="userSpin" :chart-title="'转动总计'" />-->
        <!--          </el-col>-->
        <!--        </el-row>-->
      </el-card>
      <el-card>
        <div slot="header" class="clearfix">
          <span>产销数据</span>
        </div>
        <el-row :gutter="12">
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <userStat ref="userStat" :type="14" reason="+" />
          </el-col>
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <userStat ref="userStat" :typ="14" :reason="'-'" />
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <userStat ref="userStat" :typ="15" :reason="'+'" />
          </el-col>
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <userStat ref="userStat" :typ="15" :reason="'-'" />
          </el-col>
        </el-row>
        <actStage />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>

import basic from '@/views/config/life-size-analog/components/basic.vue'
import botTable from '@/views/config/life-size-analog/components/table.vue'
import userStat from '@/views/config/life-size-analog/components/user-stat.vue'
import userSpin from '@/views/config/life-size-analog/components/stat.vue'
import actStage from '@/views/config/life-size-analog/components/actStage.vue'
import { getBotStatDataList } from '@/api/config/robot'
import { getLastDates } from '@/utils'
export default {
  name: 'LifeSizeAnalog',
  components: {
    basic,
    botTable,
    userStat,
    userSpin,
    actStage
  },
  data() {
    return {
      queryParams: {
        startDate: '',
        endDate: ''
      },
      data: []
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.queryParams.startDate = getLastDates(7)
      }
      if (!this.queryParams.endDate) {
        this.queryParams.endDate = getLastDates(0)
      }
      this.getBotStat()
    },
    getBotStat() {
      getBotStatDataList(this.queryParams).then(res => {
        this.data = res.data
        // this.$refs.userSpin.refresh(res.data)
        this.$refs.botAttackStat.refresh(res.data)
        this.$refs.botStealStat.refresh(res.data)
      })
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 15px;
}
</style>
